<template>
  <div>
    <!--政策法规-->
    <div class="border-1 m-t-6 in-box bg-fff">
      <h2>
        <span class="fl fr1">
          <a :href="baseUrl + '/childClass?classId=316382627460'" accesskey="x" title="政策法规">政策法规</a>
        </span>
      </h2>
      <ul class="in-list1">
        <li v-for="(item,index) in zhengce" :key="index" style="height: 24px;">
          <a :href="baseUrl + (item.templet+'?newsId='+item.newsId)" class="txt">{{item.newsTitle}}</a>
        </li>
      </ul>
      <div class="more1div" v-if="zhengce.length>0">
        <a
          :href="baseUrl + '/newsClass?classId='+zhengce[0].classId"
          class="fr m-r-6 more1"
          title="查看通知公告所有内容"
        >更多&gt;&gt;</a>
      </div>
    </div>
  </div>
</template>
<script>
import { sendText2Cloud } from "../../../assets/wza/js/speak";
import { startPointSpeak } from "../../../assets/wza/js/speak";
import news from "../../../http/web/news";
import { mapState } from "vuex";
export default {
  data() {
    return {
      zhengce: []
    };
  },
  computed: {
    ...mapState({
      baseUrl: state => state.global.baseUrl
    })
  },
  beforeCreate() {
    news
      .queryByCName("政策法规")
      .then(res => {
        res.forEach((item, index) => {
          if (index < 7) {
            this.zhengce.push(item);
          }
        });
      })
      .then(() => {
        sendText2Cloud();
        startPointSpeak(undefined, this.$store);
      });
  }
};
</script>
<style scoped>
.txt {
  width: 210px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-decoration: none;
  display: inline-block;
  text-align: left;
  line-height: 24px;
}
</style>


// WEBPACK FOOTER //
// src/views/clgk/components/zcfg.vue